import React, { useEffect, useRef, useState } from 'react';
import styles from './ReferenceLink.module.scss';
import cx from 'classnames';
import icons from '../../assets';
import { getCuratorSettings } from '../../api/curator';
import { useUserContext } from '../../contexts/UserContext';
import { useDispatch, useSelector } from 'react-redux';
import { selectMeasureUnitList } from '../../redux/slicers/admin/curatorSlicer';
import { convertMetersToUnits, convertToMeters } from '../../helpers/jsHelper';
import { selectMeasureUnit } from '../../redux/slicers/admin/curatorSlicer';
import {
  requestsSelector,
  setNextButtonEnabled,
  setNextButtonHovered,
  setNextButtonToolTip,
  setRequestData,
} from '../../redux/slicers/requestSlicer';
import { apiUpdateRequestFiles, apiUploadRequestFiles } from '../../helpers/api';

function Dimensions({ defaultData, isReadOnly, files }) {
  const MEASURE_UNITS = [
    { id: 1, name: 'inches', isSelected: false },
    { id: 2, name: 'feet', isSelected: true },
    { id: 3, name: 'cm', isSelected: false },
    { id: 4, name: 'meter', isSelected: false },
  ];

  const activeUnit = useSelector(selectMeasureUnit);
  const _requestSelector = useSelector(requestsSelector);

  const [dimId, setDimId] = useState(1);
  const [showDropDown, setShowDropDown] = useState({});
  const [unit, setUnit] = useState();
  const { RequestDeleteIcon } = icons;
  const { currentUser } = useUserContext();
  const dispatch = useDispatch();
  const dataRef = useRef();

  const [dimensions, setDimensions] = useState([]);

  const DIMENSIONS = ['Width', 'Depth', 'Height'];

  const handleChange = (value, _id, _index) => {
    const _dimensions = dimensions.map((_item) => {
      const item = Object.assign({}, _item);

      if (item.id === _id) {
        item[_index] = value >= 0 ? parseFloat(value) : '';
        item.unit = unit;
      }

      return item;
    });

    setDimensions(_dimensions);
  };

  const handleAddDimension = () => {
    if(_requestSelector.nextButtonHovered) dispatch(setNextButtonHovered(false))
    setDimensions([...dimensions, { id: dimId + 1, Width: '', Height: '', Depth: '' }]);
    setDimId(dimId + 1);
  };

  const handleEnterPress = (e) => {
    if (e.keyCode === 13) {
      handleAddDimension();
      e.target.blur();
    }
  };

  const handleClick = (_id, _item, e) => {
    e.stopPropagation();
    setShowDropDown({ [_id]: { [_item]: !showDropDown[_id]?.[_item] } });
  };

  const handleDeleteClick = (_id) => {
    setDimensions(dimensions.filter((item) => item.id !== _id));
    setDimId(dimId - 1);
  };

  const handleTitleChange = (value, _id) => {
    const _dimensions = dimensions.map((_item) => {
      const item = Object.assign({}, _item);
      if (item.id === _id) item.title = value;
      return item;
    });
    setDimensions(_dimensions);
  };

  const handleUnitChange = (_unit) => {
    const convertUnitToActive = (value) => {
      // if (!unit || unit.name.toUpperCase() === MEASURE_UNIT_NAME.METER) {
      //   return value;
      // }
      const meters = convertToMeters(value, unit.name.toUpperCase());

      return convertMetersToUnits(meters, _unit.name.toUpperCase());
    };

    const toFixedValue = _unit?.id === 4 ? 4 : 2;

    const _dimensions = dimensions.map((_item) => {
      const dim = Object.assign({}, _item);
      DIMENSIONS.map((_dim) => {
        dim[_dim] = convertUnitToActive(dim[_dim]).toFixed(toFixedValue);
        dim.unit = _unit;
      });
      return dim;
    });

    setDimensions(_dimensions);
    setUnit(_unit);
    setShowDropDown([]);
  };

  useEffect(() => {
    if(_requestSelector.nextButtonHovered) dispatch(setNextButtonHovered(false))
    dispatch(getCuratorSettings({ userId: currentUser.user.id }));
    if (isReadOnly) return;
    window.addEventListener('click', () => setShowDropDown([]));

    return async () => {
      dispatch(setNextButtonToolTip(null));
      window.removeEventListener('click', () => setShowDropDown([]));
      if (dataRef.current?.length) {
        const formData = new FormData();
        const _dim_id = dataRef.current[0].actual_id;

        if (_dim_id) {
          formData.append('dimensions', JSON.stringify(dataRef.current));
          await apiUpdateRequestFiles(_dim_id, formData);
          formData.delete('dimensions');
        } else {
          formData.append('file_type', 'dimensions');
          formData.append('three_d_model_request', _requestSelector.currentRequestId);
          formData.append('dimensions', JSON.stringify(dataRef.current));
          await apiUploadRequestFiles(formData);
        }
      }
    };
  }, []);

  useEffect(() => {
    setDimensions(
      (defaultData?.length && defaultData) || [
        { id: dimId, Width: '', Depth: '',Height: '',  title: 'Overall dimensions *' },
      ]
    );

    setDimId(defaultData?.length || 1);
    if (defaultData && defaultData[0]?.unit) setUnit(defaultData[0]?.unit);
  }, [defaultData]);

  useEffect(() => {
    let _unit = activeUnit;
    if (defaultData && defaultData[0]?.unit) _unit = defaultData[0]?.unit;
    else if (!activeUnit) {
      _unit = { id: 1, name: 'inches', isSelected: true };
    }
    setUnit(_unit);
  }, [activeUnit]);

  useEffect(() => {
    if (!isReadOnly) dispatch(setRequestData(dimensions));

    const dimensionsWithValue = dimensions.filter(
      (_dim) => _dim.Width || _dim.Height || _dim.Depth
    );

    if (dimensionsWithValue.length) {
      dataRef.current = dimensionsWithValue;
    }

    let enableNext = true;
    dimensions.forEach((_dim) => {
      if (
        !parseFloat(_dim.Width) ||
        !parseFloat(_dim.Height) ||
        !parseFloat(_dim.Depth) ||
        !_dim.title
      ) {
        enableNext = false;
        return;
      }
    });

    if (!enableNext) dispatch(setNextButtonToolTip('All the fields must be filled.'));
    else dispatch(setNextButtonToolTip(null));

    dispatch(setNextButtonEnabled(enableNext));
  }, [dimensions, files]);

  return (
    <div>
      <div className={cx('d-flex flex-column', !isReadOnly && 'pt-3 gap-3')}>
        {dimensions.map((dim, _index) => (
          <div className={styles.wrapper}>
            <div className={cx('d-flex justify-content-between', styles.mainTitle)}>
              {dim.id !== 1 ? (
                <div className="d-flex gap-3 w-100">
                  <input
                    type="text"
                    placeholder={isReadOnly ? 'No Name Given' : 'Enter Name'}
                    className={cx("w-100", !isReadOnly && !dim.title && (_index !== dimensions.length-1 || _requestSelector.nextButtonHovered) && styles.error)}
                    value={dim.title}
                    onChange={(e) => handleTitleChange(e.target.value, dim.id)}
                    readOnly={isReadOnly}
                  />
                  {!isReadOnly ? (
                    <div onClick={() => handleDeleteClick(dim.id)}>
                      <RequestDeleteIcon />
                    </div>
                  ) : null}
                </div>
              ) : (
                <h6>{dim.title}</h6>
              )}
            </div>
            <div className="d-flex gap-3 pt-3">
              {DIMENSIONS.map((item) => (
                <div className="d-flex flex-column gap-2" style={{ width: '30%' }}>
                  <h6 style={!isReadOnly && !dim[item] && (_index !== dimensions.length-1 || _requestSelector.nextButtonHovered) ? {color:"#e40303"}:{}}>{item}</h6>
                  <div className="input-group">
                    <input
                      placeholder="0"
                      type="number"
                      key={dim.id}
                      value={dim[item]}
                      onChange={(e) => handleChange(e.target.value, dim.id, item)}
                      onKeyDown={handleEnterPress}
                      className={cx('form-control', styles.dimensionInput, !isReadOnly && !dim[item] && (_index !== dimensions.length-1 || _requestSelector.nextButtonHovered) && styles.error)}
                      readOnly={isReadOnly}
                      step={0.01}
                    />
                    <div className="input-group-append">
                      <button
                        type="button"
                        className={cx(
                          `btn btn-outline-secondary ${
                            !isReadOnly && 'dropdown-toggle dropdown-toggle-split'
                          }`,
                          styles.dropdownButton,
                          !isReadOnly && !dim[item] && (_index !== dimensions.length-1 || _requestSelector.nextButtonHovered) && styles.errorButton
                        )}
                        onClick={(e) => handleClick(dim.id, item, e)}
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        readOnly={isReadOnly}
                        aria-expanded="false">
                        <span className="pe-3">{unit?.name}</span>
                        {!isReadOnly ? <span className="sr-only">Toggle Dropdown</span> : null}
                      </button>
                      {showDropDown[dim.id]?.[item] && (
                        <div className={cx('dropdown-menu', styles.dropDownMenu)}>
                          {MEASURE_UNITS.map(
                            (item) =>
                              item.id !== unit.id && (
                                <a
                                  className="dropdown-item"
                                  onClick={(e) => handleUnitChange(item, e)}>
                                  {item.name}
                                </a>
                              )
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {dimensions.length <= 20 && dimensions.at(-1).id === dim.id && !isReadOnly && (
              <div className={styles.addLink}>
                <span onClick={handleAddDimension}>+ Add other dimensions</span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Dimensions;
